<template>
    <!-- 监审重点 -->
    <div class="details">
        <header class="title">
            <span class="pole"></span>
            <span class="str">监审重点</span>
        </header>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">评估人天数</van-col>
            <van-col span="16" class="lr">{{ info.assessManDay }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="8" class="caption">要求完成时间</van-col>
            <van-col span="16" class="lr">{{ info.claimEndTime }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="16" class="caption">初查含方案编制人天</van-col>
            <van-col span="8" class="lr">{{ info.firstCheckManDay }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="16" class="caption">项目实施监审重点人天</van-col>
            <van-col span="8" class="lr">{{ info.inspectionManDay }}</van-col>
        </van-row>
        <van-row type="flex" justify="space-between" class="content">
            <van-col span="16" class="caption">报告编制人天</van-col>
            <van-col span="8" class="lr">{{ info.compileManDay }}</van-col>
        </van-row>
        <ul class="content" v-show="info.property=='1'">
            <li class="caption" style="margin-bottom: 7px;">审计依据</li>
            <li>{{ info.auditBasis }}</li>
        </ul>
        <ul class="content" v-show="info.property=='1'">
            <li class="caption" style="margin-bottom: 7px;">审计重点策略</li>
            <li>{{ info.strategy }}</li>
            <!-- <li>2、出差杭州力龙、常熟索特、娄底中兴三家公司现场对刀具管理进行检查；</li>
            <li>3、确认问题点并进行原因分析和对策</li> -->
        </ul>

        <ul class="content" v-if="info.riskList.length > 0">
            <li class="caption" style="margin-bottom: 7px;">风险点列表</li>
            <van-row type="flex" style="line-height: 20px;">
                <van-col span="7">风险编号</van-col>
                <van-col span="12">风险点名称</van-col>
                <van-col span="5" style="text-align: center;">风险等级</van-col>
            </van-row>
            <van-row type="flex" style="line-height: 20px;border-top: 1px solid #f3f3f3;" v-for="(item,index) in info.riskList" :key="index">
                <van-col span="7">{{ item.object.riskId }}</van-col>
                <van-col span="12">{{ item.object.riskName }}</van-col>
                <van-col span="5" style="text-align: center;">{{ item.object.riskLevelName }}</van-col>
            </van-row>
        </ul>
        <ul class="content" v-if="info.clueList.length > 0">
            <li class="caption" style="margin-bottom: 7px;">线索列表</li>
            <van-row type="flex" style="line-height: 20px;">
                <van-col span="7">线索编号</van-col>
                <van-col span="12">线索名称</van-col>
                <van-col span="5" style="text-align: center;">线索等级</van-col>
            </van-row>
            <van-row type="flex" style="line-height: 20px;border-top: 1px solid #f3f3f3;" v-for="(item,index) in info.clueList" :key="index">
                <van-col span="7">{{ item.clueId }}</van-col>
                <van-col span="12">{{ item.title }}</van-col>
                <van-col span="5" style="text-align: center;">{{ item.degreeStr }}</van-col>
            </van-row>
        </ul>
    </div>
</template>
<script>
export default{
    props: {
        info: {
            type: Object,
            require: true
        }
    }
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    //预览标题颜色
    @previewColor: #000;
    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str,.str_border_null{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
            }
            .str_border_null{
                border: unset;
                width: 80%;
                margin-bottom: 15px;
            }
            .icon{
                float: right;
                font-size: 16px;
                font-weight: bold;
            }
            .show{
                position: absolute;
                right: 0;
                top: 4px;
            }
        }
        .content{
            margin: 10px 15px 5px 23px;
            padding-bottom: 3px;
            border-bottom: 1px solid #f3f3f3;
            .caption{
                color: @contentColor;
                img{
                    border: 1px solid #000 !important;
                    border-radius: @borderRadius !important;
                }
            }
            .lr{
                text-align: right;
                position: relative;
                span{
                    position: absolute;
                    right: 0;
                    top: 0;
                    display: inline-block;
                    border: 1px solid rgba(121, 121, 121, 1);
                }
                .spot_second{
                    top: 4px;
                }
                .spot_three{
                    top: 8px;
                }
            }
            .txt{
                margin-top: 15px;
                .txt_size{
                    color: @contentColor;
                }
            }

            .preview_content_left{
                text-align: center;
                box-sizing: border-box;
                .content_left_title{
                    font-size: @middleSize;
                    font-weight: 700;
                    color: @previewColor;
                    margin: 30px 0;
                }
                .content_block_box{
                    font-size: @contentSize;
                    color: @contentColor;
                    margin-top: 20px;
                    p{
                        color: @previewColor;
                        text-align: left;
                        font-weight: bold;
                        font-size: 13px;
                    }
                    .content_left_text{
                        background-color: #f0f4ff;
                        padding: 10px;
                        box-sizing: border-box;
                        border-radius: 4px;
                        margin-top: 5px;
                        color:#333;
                        text-align:justify;
                        text-indent: 13px;
                        line-height: 20px;
                        span{
                            font-family: 楷体;
                        }
                    }
                    .color{
                        color: @titleColor;
                    }
                }
            }
            
        }
        .content:last-child{
            border: unset;
        }
        .step{
            h3{
                padding: 0;
                margin: 0 0 5px 0;
                overflow: hidden;
                .fr{
                    float: right;
                }
            }
            p{
                padding: 0;
                margin: 0 0 5px 0;
                font-size: 12px;
            }
            div{
                margin-left: 10px;
            }
        }
    }
</style>